<script lang="ts" setup>
interface GwBlindsItemProps {
  value: (string | number)[]
}

withDefaults(defineProps<GwBlindsItemProps>(), {})
</script>
<template>
  {{ value.map(i => Number(i)).join(' / ') }}
</template>
